import { Link } from "wouter";
import Genero from "./GenresData";

function GenresMap() {
  return (
    <section className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 text-white text-center gap-2 mx-auto justify-center mt-4">
      {Genero.map((item, index) => (
        <div
          key={index}
          className="uppercase genreTitle descrip z-10 hover:text-red-500 cursor-default mx-auto inline-block"
        >
          <span>{item.name}</span>
          <br />
          <Link to={item.url}>
            <img
              loading="eager"
              decoding="async"
              src={item.img}
              title={item.title}
              className="cursor-pointer inline-block img-fluid border h-40 w-40 md:h-48 md:w-48 xl:h-60 xl:w-60 rounded-xl card mx-auto mb-5 hover:scale-105 mt-2"
              alt={item.title}
            />
          </Link>
        </div>
      ))}
    </section>
  );
}

export default GenresMap;
